export interface BusinessReportArray {
  id: number; // ← APIのフィールド名に合わせる
  date: string; // "YYYY-MM-DD"
  projectId: number; // 保存用
  projectNo: string; // 表示用
  projectName: string; // 表示用
  manHoursCategory: 'A' | 'B' | 'C' | 'D' | 'E' | '';
  startTime: string; // "HH:mm"
  endTime: string; // "HH:mm"
  manHoursTotal: number;
  // editable: boolean; // 行の編集可否
}

export type BusinessReportsGetResponse = {
  items: BusinessReportArray[];
  page: number;
  totalPages: number;
};

export const EmptyBusinessReportsGetResponse: BusinessReportsGetResponse = {
  items: [
    {
      id: 0,
      date: '',
      projectId: 0,
      projectNo: '',
      projectName: '',
      manHoursCategory: '',
      startTime: '',
      endTime: '',
      manHoursTotal: 0,
    },
  ],
  page: 1,
  totalPages: 0,
};
